import { graphql } from "@server/gql";

export const getWalleyCheckoutFormQuery = graphql(/* GraphQL */ `
  query getWalleyCheckoutForm(
    $cartId: String!
    $marketCode: String!
    $brandCode: String!
    $type: String!
    $shopCallbackUrl: String!
    $shopTermsUrl: String!
    $newSession: Boolean
    $storeCode: Int
    $elevateSessionKey: String
    $elevateCustomerKey: String
    $elevateMarket: String
    $cookies: JSON
  ) {
    walleyCheckoutForm(
      cartId: $cartId
      marketCode: $marketCode
      brandCode: $brandCode
      type: $type
      shopCallbackUrl: $shopCallbackUrl
      shopTermsUrl: $shopTermsUrl
      newSession: $newSession
      storeCode: $storeCode
      elevateSessionKey: $elevateSessionKey
      elevateCustomerKey: $elevateCustomerKey
      elevateMarket: $elevateMarket
      cookies: $cookies
    ) {
      status
      cartId
      formHtml
      orderNumber
    }
  }
`);
